import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import segmentReadAction from './segmentRead.action.json' with { type: 'json' }

const segmentReadDefinition = defineReadAutoAction(segmentReadAction, 'segment')

export default segmentReadDefinition
